import { render, staticRenderFns } from "./SortArrow.vue?vue&type=template&id=2cbdae80&"
import script from "./SortArrow.vue?vue&type=script&lang=js&"
export * from "./SortArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports